// extracted by mini-css-extract-plugin
export var articleContent = "ArticleContent-module--articleContent--0c53a";
export var columnContainer = "ArticleContent-module--columnContainer--16f8b";
export var container = "ArticleContent-module--container--008d5";
export var equals = "ArticleContent-module--equals--10639";
export var moreNews = "ArticleContent-module--moreNews--2a199";
export var sidebar = "ArticleContent-module--sidebar--cc5ce";
export var utilityBar = "ArticleContent-module--utilityBar--0f907";